<div class="wrapper">
    <div class="mrt-75">
        <div class="page-title">
            <label class="page-caption" style="color: white;">Zendesk Comments</label>
        </div>
        <div class="add-button-box">
            <div class="col-md-12">
                <button (click)="onAddComment()" class="add-button hand-link">Add Comment</button>
            </div>
        </div>

        <div class="row" *ngIf="commentsList.length>0">
            <ag-grid-angular class="ag-theme-balham grid"
                [rowData]="gridOptions.rowData" [columnDefs]="gridOptions.columnDefs" [defaultColDef]="gridOptions.defaultColDef"
                [domLayout]="domLayout"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>
            </div>
            
            <ng-template #comment let-c="close" let-d="dismiss">
                <div class="modal-header blue-bg" style="padding:10px !important;">
                    <h2 class="modal-title" style="margin:0px !important" id="modal-basic-title">{{popupHeading}}</h2>
                    <button type="button" style="color: white;" class="close" (click)="d('Close click')">&times;</button>
                  </div>
                  <div class="modal-body">
                    <div class="col-md-12">
                        <label class="name">Name</label>
                        <input class="form-control" maxlength="60" type="text" [(ngModel)]="commentName" (ngModelChange)="onFieldChange('name')"/>
                        <p class="validation-text" *ngIf="showNameError && commentName.length < 4">Minimum 4 characters are required.</p>                    
                    </div>
                    <!-- <div class="col-md-12">
                        <p *ngIf="privilegeName.length==0" class="validation-text">Please enter privilege name</p>
                        <p *ngIf="privilegeName.length>50" class="validation-text">Privilege name should be equal or less than 50 characters</p>
                    </div> -->
                    <div class="col-md-12">
                        <label class="name">Description</label>
                        <input class="form-control" maxlength="60" type="text" [(ngModel)]="commentDescription" (ngModelChange)="onFieldChange('description')"/>
                        <p class="validation-text" *ngIf="showDescriptionError && commentDescription.length < 4">Minimum 4 characters are required.</p>
                    </div>
                    <div class="col-md-12">
                        <label class="name">Value</label>
                        <input class="form-control" maxlength="51" type="text" [(ngModel)]="commentValue" (ngModelChange)="onFieldChange('value')"/>
                        <p class="validation-text" *ngIf="showValueError && commentValue.length < 4">Minimum 4 characters are required.</p>
                    </div>

                  </div>
                    <div class="modal-footer">
                        <button type="button" class="btn add-button custom-btn" 
                        [disabled]="commentName.length < 4 || commentDescription.length < 4 || commentValue.length < 4"
                        (click)="saveComment(commentId)">Save</button>
                        <button type="button" class="btn cancel-btn" (click)="c('Close click')">Cancel</button>
                      </div>
            </ng-template>
            <ng-template #commentEdit let-c="close" let-d="dismiss">
                <div class="modal-header blue-bg" style="padding:10px !important;">
                    <h2 class="modal-title" style="margin:0px !important" id="modal-basic-title">{{popupHeading}}</h2>
                    <button type="button" style="color: white;" class="close" (click)="d('Close click')">&times;</button>
                  </div>
                  <div class="modal-body">
                    <div class="col-md-12">
                        <label class="name">ID</label>
                        <input class="form-control" type="text" [(ngModel)]="commentId" disabled/>
                    </div>
                    <div class="col-md-12">
                        <label class="name">Name</label>
                        <input class="form-control" type="text" [(ngModel)]="commentName" disabled/>
                    </div>
                    <div class="col-md-12">
                        <label class="name">Description</label>
                        <input class="form-control" type="text" [(ngModel)]="commentDescription" disabled/>
                    </div>
                    <div class="col-md-12">
                        <label class="name">Value</label>
                        <input class="form-control" maxlength="250" type="text" [(ngModel)]="commentValue"/>
                    </div>

                  </div>
                    <div class="modal-footer">
                        <button type="button" class="btn add-button custom-btn" 
                        [disabled]="commentValue == originalCommentValue"
                        (click)="saveComment(commentId)">Save</button>
                        <button type="button" class="btn cancel-btn" (click)="c('Close click')">Cancel</button>
                      </div>
            </ng-template>
        </div>
    
    </div>